'use strict';

ossSliderArrows.$inject = ['$timeout', '$window'];

function ossSliderArrows($timeout, $window) {
    var directive = {
        restrict: 'A',
        require: "^horyzontalScroll",
        link: link
    };

    return directive;

    function link(scope, element, attrs, ctrl) {
        var timer = null;
        var container = element.parent()[0];
        var wrapper = element[0];
        var nextBtn = angular.element(container.getElementsByClassName('js-btn-next'));
        var prevBtn = angular.element(container.getElementsByClassName('js-btn-prev'));

        nextBtn.addClass('disabled');
        prevBtn.addClass('disabled');

        element.bind('scroll', function () {
            $timeout.cancel(timer);
            timer = $timeout(function () {
                setArrowsVisibility();
            }, 250);
        });

        scope.$watch(function () { return wrapper.scrollWidth }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                setArrowsVisibility();
            }
        });

        timer = $timeout(function () {
            setArrowsVisibility();
        }, 0);

        angular.element($window).on('resize', onResize);

        function onResize() {
            $timeout.cancel(timer);
            timer = $timeout(function () {
                setArrowsVisibility();
            }, 500);
        }

        function setArrowsVisibility() {
            //round scrollLeft for remove sub-pixels value on zoom
            var scrollPos = Math.round(wrapper.scrollLeft);
            var wrapperRightOffset = scrollPos + wrapper.clientWidth;
            if (wrapper.scrollWidth <= wrapper.clientWidth) {
                nextBtn.addClass('disabled');
                prevBtn.addClass('disabled');
            } else if (scrollPos == 0) {
                nextBtn.removeClass('disabled');
                prevBtn.addClass('disabled');
            } else if (wrapperRightOffset >= wrapper.scrollWidth) {
                nextBtn.addClass('disabled');
                prevBtn.removeClass('disabled');
            } else {
                nextBtn.removeClass('disabled');
                prevBtn.removeClass('disabled');
            }
        }

        scope.$on('$destroy', function (event) {
            $timeout.cancel(timer);
            angular.element($window).off('resize', onResize);
        });
    }
}

module.exports = ossSliderArrows;